import React from "react";

export default function StatusBadge({ status, label, className = "" }) {
  const map = {
    active:        { cls: "green",  text: label || "Active" },
    idle:          { cls: "amber",  text: label || "Idle" },
    maintenance:   { cls: "slate",  text: label || "Maintenance" },
    alert:         { cls: "red",    text: label || "Alert" },
    critical:      { cls: "red",    text: label || "Critical" },
    warning:       { cls: "amber",  text: label || "Warning" },
    normal:        { cls: "green",  text: label || "Normal" },
    closed:        { cls: "slate",  text: label || "Closed" },
    "in-progress": { cls: "blue",   text: label || "In Progress" },
    open:          { cls: "amber",  text: label || "Open" },
    on_time:       { cls: "green",  text: label || "On Time" },
    at_risk:       { cls: "amber",  text: label || "At Risk" },
    breached:      { cls: "red",    text: label || "Breached" },
    renewed:       { cls: "green",  text: label || "Renewed" },
    expired:       { cls: "red",    text: label || "Expired" },
    new:           { cls: "blue",   text: label || "New" },
  };
  const k = (status || "").toLowerCase();
  const m = map[k] || { cls: "slate", text: label || status || "—" };
  return <span className={`status-pill ${m.cls} ${className}`}>{m.text}</span>;
}
